import React from 'react';
import { TextField, Box } from '@mui/material';
import { useLanguage } from '../../i18n/LanguageContext';

interface BodyWeightFormProps {
  weightValue: string;
  fatPercentageValue: string;
  waistCircumferenceValue: string;
  onWeightChange: (value: string) => void;
  onFatPercentageChange: (value: string) => void;
  onWaistCircumferenceChange: (value: string) => void;
  disabled?: boolean;
}

export const BodyWeightForm: React.FC<BodyWeightFormProps> = ({
  weightValue,
  fatPercentageValue,
  waistCircumferenceValue,
  onWeightChange,
  onFatPercentageChange,
  onWaistCircumferenceChange,
  disabled = false,
}) => {
  const { t } = useLanguage();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label={t('bodyweight.weight')}
        type="number"
        value={weightValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onWeightChange(e.target.value)}
        sx={{ width: '100%' }}
        disabled={disabled}
        autoFocus
        required
      />
      <TextField
        label={t('bodyweight.fatPercentage')}
        type="number"
        value={fatPercentageValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onFatPercentageChange(e.target.value)}
        sx={{ width: '100%' }}
        disabled={disabled}
        placeholder="Optional"
        inputProps={{
          min: 0,
          max: 100,
          step: 0.1
        }}
      />
      <TextField
        label={t('bodyweight.waistCircumference')}
        type="number"
        value={waistCircumferenceValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onWaistCircumferenceChange(e.target.value)}
        sx={{ width: '100%' }}
        disabled={disabled}
        placeholder="Optional"
        inputProps={{
          min: 0,
          max: 200,
          step: 0.1
        }}
      />
    </Box>
  );
}; 